import { onMounted, onUnmounted } from '@vue/composition-api';

export interface ConfigModel {
  immediate?: boolean
}

export const useResizeListener = (
  handler: () => void,
  config?: ConfigModel
) => {
  onMounted(() => {
    if (typeof handler !== 'function') {
      return;
    }
    window.addEventListener('resize', handler);
    config?.immediate && handler();
  });

  onUnmounted(() => window.removeEventListener('resize', handler));
}; 